import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

import { designSystem } from '@/styles/styles';

const SvgComponent = props => (
    <Svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" fill="none">
        <Path
            d="M12 14.5C10.4087 14.5 8.88258 13.8679 7.75736 12.7426C6.63214 11.6174 6 10.0913 6 8.5V3H18V8.5C18 10.0913 17.3679 11.6174 16.2426 12.7426C15.1174 13.8679 13.5913 14.5 12 14.5ZM12 14.5V17.5M18 5H20.5C20.7652 5 21.0196 5.10536 21.2071 5.29289C21.3946 5.48043 21.5 5.73478 21.5 6V7.5C21.5 8.29565 21.1839 9.05871 20.6213 9.62132C20.0587 10.1839 19.2956 10.5 18.5 10.5H18M6 5H3.5C3.23478 5 2.98043 5.10536 2.79289 5.29289C2.60536 5.48043 2.5 5.73478 2.5 6V7.5C2.5 8.29565 2.81607 9.05871 3.37868 9.62132C3.94129 10.1839 4.70435 10.5 5.5 10.5H6M7 20V18.5C7 18.2348 7.10536 17.9804 7.29289 17.7929C7.48043 17.6054 7.73478 17.5 8 17.5H16C16.2652 17.5 16.5196 17.6054 16.7071 17.7929C16.8946 17.9804 17 18.2348 17 18.5V20C17 20.2652 16.8946 20.5196 16.7071 20.7071C16.5196 20.8946 16.2652 21 16 21H8C7.73478 21 7.48043 20.8946 7.29289 20.7071C7.10536 20.5196 7 20.2652 7 20Z"
            stroke={props.fill || designSystem.colors.neutral300}
            strokeWidth={1.75}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </Svg>
);
export default SvgComponent;
